export enum DELIMITERS {
    LATEX_START = '@@@STARTLATEX@@@',
    LATEX_END = '@@@ENDLATEX@@@',
    LATEX_STEP_SEPARATOR = '@@@STEPSEPARATORLATEX@@@'
}
